import { handleInteractiveKeydown } from '@fullstory/util/a11y';
import React, { AriaAttributes, PropsWithChildren, useContext } from 'react';
import { identifyComponent } from '../../util';
import { CollapsibleSectionContext } from './Context';
import css from './index.module.scss';
import { getPanelId } from './utils';

interface CollapsibleSectionHeader extends Pick<AriaAttributes, 'aria-label'> {}

export const CollapsibleSectionHeader: React.FunctionComponent<
  PropsWithChildren<CollapsibleSectionHeader>
> = ({ children, ...rest }) => {
  const { setCollapsed, collapsed, id, testId } = useContext(CollapsibleSectionContext);

  function toggleCollapse() {
    setCollapsed(!collapsed);
  }

  return (
    <div
      data-component="CollapsibleSectionHeader"
      onClick={toggleCollapse}
      aria-expanded={!collapsed}
      aria-controls={getPanelId(id)}
      tabIndex={0}
      role="button"
      onKeyDown={handleInteractiveKeydown(toggleCollapse)}
      className={css.header}
      data-testid={testId && `${testId}-header`}
      {...rest}
      {...identifyComponent('collapsible-section-header', rest)}
    >
      {children}
    </div>
  );
};
